import React from "react";
import {
  levelTranslate,
  categorySectionTranslate
} from "../../../commons/util";
import { useAppState } from "../../AppContext";
import {
  setModalAcquiredReliabilitiesVisibility,
  viewUserReliabilitiesByLevel
} from "../actions";

export default function AcquiredReliabilities({ level }) {
  const [state, dispatch] = useAppState();

  const viewUserReliabilities = levelId => {
    dispatch(setModalAcquiredReliabilitiesVisibility(true));
    dispatch(viewUserReliabilitiesByLevel({ levelId }));
  };

  return (
    <div
      className="reliability-card-inactive"
      onClick={() => viewUserReliabilities(level.level.id)}
    >
      <h4>{level.level.titulo}</h4>
      {level.categories &&
        level.categories
          .filter(cat => cat.anyAcquired)
          .map(cat => (
            <div className="acquiredCategory" key={cat.category.id}>
              {cat.reliabilities &&
                cat.reliabilities
                  .filter(rel => rel.acquired)
                  .reduce((acc, current) => {
                    const categoryAlreadListed = acc.some(
                      r => r.category === current.category
                    );
                    if (!categoryAlreadListed) {
                      acc.push(current);
                    }
                    return acc;
                  }, [])
                  .map(rel => (
                    <div
                      key={rel.reliability.id}
                      className="acquired-reliability"
                    >
                      <img
                        src={levelTranslate(Number(cat.category.nivel))}
                      ></img>
                      <p className="reliability-card-acquired-category-title">
                        {categorySectionTranslate(cat.section)}
                      </p>
                    </div>
                  ))}
            </div>
          ))}
    </div>
  );
}
